import React from 'react'
import { Form, Input, Button, Modal, InputNumber, Switch, DatePicker, Checkbox, Radio, Row, Col } from 'antd'
import FileUpload from './UploadPicture'
import moment from 'moment'
import locale from 'antd/lib/date-picker/locale/ru_RU'
import DefaultImage from '../../shared/DefaultImage'
import ComboAction from './Combo'
import SellersAction from './Sellers'

moment.locale('ru')

const FormItem = Form.Item
const { TextArea } = Input

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okType: 'danger',
      okText: 'Да',
      cancelText: 'Нет',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { formFieldValues } = this.props
    const isCreateForm = this.props.type === 'create'

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }

    const disabledDateStart = (current) => {
      const values = this.props.formFieldValues
      return current && (!!values && !!values.d_end && !!values.d_end.value) ? current >= moment(values.d_end.value._d).endOf('day') : false
    }

    const disabledDateEnd = (current) => {
      const values = this.props.formFieldValues
      return current && (!!values && !!values.d_begin && !!values.d_begin.value) ? current < moment(values.d_begin.value._d).endOf('day') : false
    }

    const changeInfinity = (current) => {
      current.target.checked && this.props.form.setFieldsValue({ d_end: moment(new Date('2100-01-01')) })
    }

    return (
      <Form onSubmit={this.handleOnSubmit} layout='vertical'>
        <FormItem label='Торговая сеть'>
          {getFieldDecorator('s_sellers', {
            getValueFromEvent: this.handleSellersChange,
            rules: [
              {
                required: true, message: 'Пожалуйста укажите торговые сети',
              },
            ],
          })(<SellersAction {...this.props} onChange={this.handleSellersChange} />)}
        </FormItem>
        <Row type='flex' justify='start' gutter={32} >
          <Col>
            <FormItem colon={false} label='Изображение' >
              {getFieldDecorator('s_picture', {
                getValueFromEvent: this.handlePictureChange,
                rules: [
                  {
                    required: true, message: 'Пожалуйста добавьте изображение',
                  },
                ],
              })(<FileUpload onChange={this.handlePictureChange} />)}
            </FormItem>
          </Col>
          <Col>
            <Row type='flex' justify='start' align='middle' gutter={32}>
              <Col>
                <FormItem label='Название' >
                  {getFieldDecorator('s_name', {
                    rules: [{ required: true, message: 'Пожалуйста введите название.' }],
                  })(<Input placeholder='Название' />)}
                </FormItem>
              </Col>
              <Col>
                <FormItem label='Начало действия' >
                  {getFieldDecorator('d_begin', {
                    initialValue: moment(),
                    rules: [{ required: true, type: 'object', message: 'Пожалуйта укажите дату начала' }],
                  })(<DatePicker locale={locale} disabledDate={disabledDateStart} />)}
                </FormItem>
              </Col>
              <Col>
                <FormItem label='Окончание действия' style={{ display: !!formFieldValues && !!formFieldValues.b_infinity && !!formFieldValues.b_infinity.value ? 'none' : 'block' }} >
                  {getFieldDecorator('d_end', {
                    initialValue: moment().add(2, 'M'),
                    rules: [{ required: true, type: 'object', message: 'Пожалуйта укажите дату окончания' }],
                  })(<DatePicker locale={locale} disabledDate={disabledDateEnd} />)}
                </FormItem>
              </Col>
              <Col>
                <FormItem label=' ' >
                  {getFieldDecorator('b_infinity', {
                    initialValue: false,
                    valuePropName: 'checked',
                  })(<Checkbox onChange={changeInfinity} >Бессрочна</Checkbox>)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormItem label='Описание'>
                  {getFieldDecorator('s_descr', {
                    rules: [{ message: 'Пожалуйста введите описание.' }],
                  })(<TextArea rows={3} placeholder='Описание' />)}
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row type='flex' justify='start' gutter={32} >
          <Col>
            <FormItem label='Максимальная сумма трат' >
              {getFieldDecorator('n_max_amount', {
                initialValue: 0,
                rules: [{ required: true, message: 'Пожалуйта укажите максимальную сумму трат' }],
              })(<InputNumber
                style={{ width: '100%' }}
                placeholder='Рублей'
                min={0}
                max={50000}
                step={1}
              />)}
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' justify='start' gutter={32}>
          <Col>
            <FormItem label='' >
              {getFieldDecorator('n_discobonus', {
                initialValue: '1',
                rules: [{ required: true, message: 'Пожалуйта укажите тип скидки' }],
              })(<Radio.Group >
                <Radio.Button value='1'>Зачисление бонусов</Radio.Button>
                <Radio.Button value='2'>Прямая скидка</Radio.Button>
                 </Radio.Group>)}
            </FormItem>
          </Col>
        </Row>
        <Row style={{ display: !!formFieldValues && !!formFieldValues.n_discobonus && formFieldValues.n_discobonus.value === '1' ? 'none' : 'flex' }} type='flex' align='middle' justify='start' gutter={32}>
          <Col>
            <FormItem label='Тип предоставляемой скидки' >
              {getFieldDecorator('n_discount_type', {
                initialValue: '1',
                rules: [{ message: 'Пожалуйта укажите тип скидки' }],
              })(<Radio.Group >
                <Radio className='radio-vertical' value='1'>Процент скидки</Radio>
                <Radio className='radio-vertical' value='2'>Аукционная цена</Radio>
                 </Radio.Group>)}
            </FormItem>
          </Col>
        </Row>
        <Row style={{ display: !!formFieldValues && !!formFieldValues.n_discobonus && formFieldValues.n_discobonus.value === '2' ? 'none' : 'flex' }} type='flex' align='middle' justify='start' gutter={32}>
          <Col className='col-center-switch'>
            <FormItem label='' >
              {getFieldDecorator('b_sleep_bonus', {
                initialValue: true,
                valuePropName: 'checked',
                rules: [{ required: true, message: 'Зачисление бонусов сразу после покупки.' }],
              })(<Switch
                checkedChildren='Да'
                unCheckedChildren='Нет'
              />)}
              <span className='span-label'>Зачисление бонусов сразу после покупки</span>
            </FormItem>
          </Col>
          <Col style={{ display: !!formFieldValues && !!formFieldValues.b_sleep_bonus && !formFieldValues.b_sleep_bonus.value ? 'flex' : 'none' }}>
            <FormItem label='' >
              <span>Начисление происходит через</span>
              {getFieldDecorator('n_sleep_bonus', {
                initialValue: 0,
                rules: [{ required: false, message: 'Начисление бонусов через n дней.' }],
              })(<InputNumber
                className='input-text-row'
                placeholder='Дней'
                size='small'
                min={0}
                max={999}
                step={1}
              />)}
              <span>дней после покупки</span>
            </FormItem>
          </Col>
        </Row>
        <Row style={{ display: !!formFieldValues && !!formFieldValues.n_discobonus && formFieldValues.n_discobonus.value === '2' ? 'none' : 'flex' }} type='flex' align='middle' justify='start' gutter={32}>
          <Col className='col-center-switch'>
            <FormItem label='' >
              {getFieldDecorator('b_fire_bonus', {
                initialValue: false,
                valuePropName: 'checked',
                rules: [{ required: true, message: 'Сгорание бонусов.' }],
              })(<Switch
                checkedChildren='Да'
                unCheckedChildren='Нет'
              />)}
              <span className='span-label'>Сгорание бонусов</span>
            </FormItem>
          </Col>
          <Col style={{ display: !!formFieldValues && !!formFieldValues.b_fire_bonus && !!formFieldValues.b_fire_bonus.value ? 'flex' : 'none' }}>
            <FormItem label='' >
              <span>Сгорание происходит через</span>
              {getFieldDecorator('n_fire_bonus', {
                initialValue: 0,
                rules: [{ required: false, message: 'Сгорание бонусов через n дней.' }],
              })(<InputNumber
                className='input-text-row'
                placeholder='Дней'
                size='small'
                min={0}
                max={999}
                step={1}
              />)}
              <span>дней после покупки</span>
            </FormItem>
          </Col>
        </Row>
        <FormItem colon={false} label='' >
          {getFieldDecorator('s_values', {
            getValueFromEvent: this.handleValuesChange,
            rules: [
              {
                required: true, message: 'Пожалуйста добавьте товары',
              },
            ],
          })(<ComboAction {...this.props} onChange={this.handleValuesChange} />)}
        </FormItem>
        <Row type='flex' justify='start' gutter={32}>
          <Col>
            <FormItem label='Активность'>
              {getFieldDecorator('n_enable', {
                valuePropName: 'checked',
                rules: [{ required: false, message: 'Активность.' }],
              })(<Switch />)}
            </FormItem>
          </Col>
        </Row>
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
            disabled
          >
            {isCreateForm ? 'Создать' : 'Сохранить'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Удалить
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props

    const isCreateForm = props.type === 'create'

    // const beginField = !!isCreateForm ? {name: 'd_begin', value: moment()} : {name: 'd_begin', value: moment(formFieldValues.d_begin && formFieldValues.d_begin.value)}
    // const endField = !!isCreateForm ? {name: 'd_end', value: moment()} : {name: 'd_end', value: moment(formFieldValues.d_end && formFieldValues.d_end.value)}

    return {
      s_name: Form.createFormField(formFieldValues.s_name),
      // s_picture: Form.createFormField(formFieldValues.s_picture),
      s_picture: Form.createFormField(isCreateForm ? { name: 's_picture', value: DefaultImage } : formFieldValues.s_picture),
      s_descr: Form.createFormField(formFieldValues.s_descr),
      d_begin: Form.createFormField(formFieldValues.d_begin),
      d_end: Form.createFormField(formFieldValues.d_end),
      b_infinity: Form.createFormField(formFieldValues.b_infinity),
      n_max_amount: Form.createFormField(formFieldValues.n_max_amount),
      n_discobonus: Form.createFormField(formFieldValues.n_discobonus),
      n_sleep_bonus: Form.createFormField(formFieldValues.n_sleep_bonus),
      b_sleep_bonus: Form.createFormField(formFieldValues.b_sleep_bonus),
      n_fire_bonus: Form.createFormField(formFieldValues.n_fire_bonus),
      b_fire_bonus: Form.createFormField(formFieldValues.b_fire_bonus),
      n_discount_type: Form.createFormField(formFieldValues.n_discount_type),
      n_discount_value: Form.createFormField(formFieldValues.n_discount_value),
      f_action_subtypes: Form.createFormField(formFieldValues.f_action_subtypes),
      s_values: Form.createFormField(isCreateForm ? { name: 's_values', value: '' } : formFieldValues.s_values),
      s_sellers: Form.createFormField(isCreateForm ? { name: 's_sellers', value: '' } : formFieldValues.s_sellers),
      n_enable: Form.createFormField(formFieldValues.n_enable),
    }
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm



// WEBPACK FOOTER //
// src/containers/ActionForm/Form.jsx